/* eslint-disable */
import React,{useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
const sampleImg = 'https://via.placeholder.com/175x250'
function ManageParkingFee() {
  const [modalOpen, setModalOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"전체", cnt:"435", value:0},
    {title:"승인 요청", cnt:"5", value:1},
    {title:"1차 승인", cnt:"5", value:2},
    {title:"승인 완료", cnt:"5", value:3},
    {title:"승인 불가", cnt:"5", value:4},
    {title:"내 요청", cnt:"5", value:5},
  ];
  return (
    <main className="com_container com_parking">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu9_11'>주차비 정산</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">주차비 청구</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top type_column'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <p className="notice">
                승인된 주차비는 회사 급여통장으로 이체됩니다. 다른 방식을 원하시면, 인사총무부로 문의하여 주세요. <br />
                &lt;필독&gt; 공영주차장 정산일자 지정제 도입 &lt;공지&gt; 21년 2월 부터 1개월 지난 영수증은 주차비 소급 적용하지않을 예정 이오니 착오 없으시길 바랍니다.
              </p>
              <hr className="com_divider" />
              <section className='com_board_search end'>
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="8%"/>
                <col width="8%"/><col width="8%"/>
                <col width="8%"/><col width="8%"/>
                <col width="8%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>요청일</th>
                  <th>요청자</th>
                  <th>수업</th>
                  <th>입차시간</th>
                  <th>출차시간</th>
                  <th>청구액</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022.08.25 12:30</td>
                  <td><button className="name btn_link">김요청103</button></td>
                  <td>영어</td>
                  <td>2022.08.25 12:30</td>
                  <td>2022.08.25 20:30</td>
                  <td>800,000</td>
                  <td className='td_red'>승인불가 <br />2022,09,25</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>2022.08.25 12:30</td>
                      <td><button className="name btn_link">김요청103</button></td>
                      <td>영어</td>
                      <td>2022.08.25 12:30</td>
                      <td>2022.08.25 20:30</td>
                      <td>800,000</td>
                      <td className='td_point'>승인완료 <br />2022,09,25</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit"/>
            </div>
            <table className='com_board_list type_row'>
              <colgroup>
                <col width="28%"/><col width="60%"/>
              </colgroup>
              <tbody>
                <tr>
                  <th>주차장 명</th>
                  <td><input type="text" className="input" defaultValue={`강남주차장`} /></td>
                </tr>
                <tr>
                  <th>방문구분</th>
                  <td>
                    <select className="select">
                      <option value="수업 - 영어">수업 - 영어</option>
                      <option value="방문">방문</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>방문사유</th>
                  <td><input type="text" className="input" defaultValue={`하승유 스터디카페 수업`} /></td>
                </tr>
                <tr>
                  <th>입차시간</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select className="select">
                        <option value="18시">18시</option>
                        <option value="17시">17시</option>
                      </select>
                      <select className="select">
                        <option value="30분">30분</option>
                        <option value="00분">00분</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>출차시간</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select className="select">
                        <option value="18시">18시</option>
                        <option value="17시">17시</option>
                      </select>
                      <select className="select">
                        <option value="30분">30분</option>
                        <option value="00분">00분</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>청구금액</th>
                  <td><input type="text" className="input" defaultValue={`78,000`} /></td>
                </tr>
              </tbody>
            </table>
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray xs wl"/>
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
            </div>
            <div className="img_box">
              <img src={sampleImg} alt="영수증 이미지" />
            </div>
            <div className="com_comment_wrap">
              <select className="select">
                <option value="승인 불가">승인 불가</option>
                <option value="승인">17시</option>
              </select>
              <textarea className="textarea" placeholder='댓글을 입력해주세요'></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange s wl">승인</div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default ManageParkingFee;
